import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var cardPane = /*#__PURE__*/css("display:flex;flex-direction:column;gap:16px;", media('>=tablet'), "{gap:24px;}");
export var cards = /*#__PURE__*/css("display:flex;flex-direction:column;gap:16px;", media('>=tablet'), "{flex-direction:row;flex-wrap:wrap;gap:24px;}");